"use client";

import { Mail, Phone, MapPin } from "lucide-react";

const contactItems = [
  {
    icon: Mail,
    label: "Email",
    value: "designook.id@gmail.com",
    href: "mailto:designook.id@gmail.com",
    isMulti: false,
  },
  {
    icon: Phone,
    label: "Phone",
    value: ["+91 70172-08147", "+91 73411-09977"],
    href: ["tel:+917017208147", "tel:+917341109977"],
    isMulti: true,
  },
  {
    icon: MapPin,
    label: "Address",
    value: [
      "CPM 09, Second Floor, Central Plaza,",
      "EMAAR MGF Sector-105, ",
      "Mohali, Punjab-140307, INDIA",
    ],
    href: "https://www.google.com/maps?sca_esv=5cbb6f2e087ee285&gs_lp=Egxnd3Mtd2l6LXNlcnAiEmRlc2lnbiBub29rIGNoYW5kaSoCCAAyBBAhGBUyBRAhGJ8FSOAaUKgDWNUNcAF4AZABAJgBuwGgAZYIqgEDMC43uAEDyAEA-AEBmAIIoAK6CMICChAAGLADGNYEGEfCAgUQABiABMICBhAAGBYYHsICCBAAGBYYChgewgIHEAAYgAQYDcICBhAAGA0YHsICCBAAGAUYDRgewgIIEAAYCBgNGB6YAwCIBgGQBgKSBwMxLjegB-srsgcDMC43uAe2CMIHBTAuMy41yAcb&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=KQkQzFoA6Q85Mc7RO2200cBj&daddr=2nd+LEVEL,+EMAAR+MGF+-+The+Views,+CENTRAL+PLAZA,+CPM+09,+Emaar+MGF+Mohali+Sector+105,+Sahibzada+Ajit+Singh+Nagar,+Punjab+140306",
    isMulti: true,
  },
];

const NavContact = () => {
  return (
    <div
      className="
        text-center md:text-left space-y-1 max-w-sm mx-auto md:mx-0 font-semibold leading-relaxed text-white
        md:border-l-2 md:border-[#A65D5D] 
        pl-0 md:pl-5
      "
    >
      {contactItems.map((item, index) => (
  <div
    key={index}
    className="
      flex 
      flex-col items-center justify-center
      md:items-start md:justify-start
      text-center md:text-left
      gap-1
    "
  >
    {/* Icon + Label in same row */}
    <div className="flex items-center gap-2">
      <item.icon className="text-[#A65D5D]" size={20} />
      <strong className="text-[#A65D5D] text-md sm:text-lg">{item.label}:</strong>
    </div>

    {/* Value(s) */}
    <div className="text-md sm:text-lg">
      {item.isMulti ? (
        Array.isArray(item.value) && item.href ? (
          item.value.map((val, i) => (
            <div key={i} className={i !== 0 ? "mt-1" : ""}>
              <a
                href={Array.isArray(item.href) ? item.href[i] : item.href}
                className="hover:text-[#A65D5D] transition duration-300"
                target="_blank"
                rel="noopener noreferrer"
              >
                {val}
              </a>
            </div>
          ))
        ) : (
          <a
            href={item.href}
            className="hover:text-[#A65D5D] transition duration-300"
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.value.map((line, i) => (
              <p key={i} className={i !== 0 ? "mt-1" : ""}>
                {line}
              </p>
            ))}
          </a>
        )
      ) : (
        <a
          href={item.href}
          className="hover:text-[#A65D5D] transition duration-300 underline-offset-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          {item.value}
        </a>
      )}
    </div>
  </div>
))}

    </div>
  );
};

export default NavContact;
